import { render, staticRenderFns } from "./AboutFacig.vue?vue&type=template&id=cb1ae35a"
import script from "./AboutFacig.vue?vue&type=script&lang=js"
export * from "./AboutFacig.vue?vue&type=script&lang=js"
import style0 from "./AboutFacig.vue?vue&type=style&index=0&id=cb1ae35a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports